/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-arrow-down-big': {
    width: 8,
    height: 146,
    viewBox: '0 0 8 146',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M7.218 142.648l-3.182 3.167a.502.502 0 01-.707 0l-3.182-3.167a.496.496 0 010-.704.502.502 0 01.707 0l2.328 2.318V.96h1v143.302l2.329-2.318a.502.502 0 01.707 0 .496.496 0 010 .704z" _fill="#fff"/>'
  }
})
